/* eslint-disable comma-dangle */
/* eslint-disable react/prop-types */
import imageUrl from "@/utils/api/imageUrl";
import { useMutation, useQuery } from "@apollo/client";
import CategoryIcon from "@mui/icons-material/Category";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Tooltip from "@mui/material/Tooltip";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import "react-circular-progressbar/dist/styles.css";
import { FiEdit, FiUserPlus } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Button, Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import {
  GET_ALL_HOLYDAYS_BY_YEAR,
  GET_ALL_KPI_DURATION,
  GET_EMPLOYEE_KPI_BY_EMPLOYEE_ID,
  GET_PENDING_LEAVES_BY_USER_ID,
  GET_USER_BY_ID,
  GET_USER_BY_USERID,
} from "../../GraphQL/Queries";
import { ageCalculator, dateTime } from "../../utils/helpers";

import {
  DELETE_USER_CERTIFICATE,
  DELETE_USER_FAMILY_INFO,
  UPDATE_EMERGENCY_FAMILY_INFO,
} from "@/GraphQL/Mutation";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";
import {
  calculateTotalLeaveDaysPerType,
  flattenPendingLeaveArray,
} from "@/utils/pendingLeave";
import moment from "moment";
import Swal from "sweetalert2";
import { decryption } from "../HelperFunctions";
import ChangePasswordModal from "./ChangePasswordModal";
import FamilyInfoModal from "./FamilyInfoModal";
import KpiFeedBackModal from "./KpiFeedBackModal";
const AgentProfile = () => {
  const [user, setuser] = useState({});

  const permissions = decryption(
    JSON.parse(localStorage?.getItem("permissions"))
  );
  const history = useHistory();
  const userId = history?.location?.state?.id;

  const usersId = userId ? userId : user.id;
  const [isChangePassword, setIsChangePassword] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [deptModalOpen, setDeptModalOpen] = useState(false);
  const [selectedFamily, setSelectedFamily] = useState(null);
  const [selectedDept, setSelectedDept] = useState(null);
  const [selectedDurationId, setSelectedDurationId] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [kpiId, setKpiId] = useState(null);
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
  const openEditModal = (family) => {
    setSelectedFamily(family);
    setEditModalOpen(true);
  };

  const openDeptModal = (userData, type, id) => {
    setSelectedFamily(userData);
    setKpiId(id);
    setModalType(type);
    setDeptModalOpen(true);
  };

  const closeEditModal = () => {
    setEditModalOpen(false);
    setSelectedFamily(null);
  };
  const closeDeptModal = () => {
    setDeptModalOpen(false);
    setModalType(null);
  };
  const loggedUser = history?.location;
  // dark mode css in
  const theme = useSelector((state) => state.theme.className);

  //
  useEffect(() => {
    const token = localStorage?.getItem("token");
    try {
      const decoded = jwtDecode(token);

      // Optional: Check for token expiry
      const isExpired = decoded.exp * 1000 < Date.now();

      if (isExpired) {
        localStorage.removeItem("token");
      } else {
        setuser(decoded);
      }
    } catch (err) {
      // Invalid token format
      localStorage.removeItem("token");
    }
  }, []);

  const LoadUserProfile = useQuery(GET_USER_BY_USERID, {
    skip: !usersId,
    variables: {
      id: Number(usersId),
    },
  });

  useEffect(() => {
    LoadUserProfile?.refetch();
  }, [LoadUserProfile?.data?.getUserByUserid?.familyInfo]);

  const { data: pendingLeave, loading: pendingLeaveLoading } = useQuery(
    GET_PENDING_LEAVES_BY_USER_ID,
    {
      variables: { user_id: Number(usersId) },
      skip: !usersId,
    }
  );

  const [filterYear, setFilterYear] = useState(
    Number(moment(new Date()).format("YYYY"))
  );
  const getAllHolydaysByYear = useQuery(GET_ALL_HOLYDAYS_BY_YEAR, {
    skip: !filterYear,
    variables: {
      year: filterYear,
    },
  });
  const holidayss = getAllHolydaysByYear?.data?.getAllHolydaysByYear;

  const totals = calculateTotalLeaveDaysPerType(
    pendingLeave?.getPendingLeavesByUserId?.data || [],
    holidayss
  );

  const totalPending = flattenPendingLeaveArray(totals);
  const [deleteUserFamilyInfo] = useMutation(DELETE_USER_FAMILY_INFO, {});
  const { data: kpiDurationData } = useQuery(GET_ALL_KPI_DURATION);
  const [deleteUserCertificate] = useMutation(DELETE_USER_CERTIFICATE, {
    refetchQueries: [GET_USER_BY_USERID],
  });
  const { data, loading, error, refetch } = useQuery(
    GET_EMPLOYEE_KPI_BY_EMPLOYEE_ID,
    {
      variables: {
        employee_id: Number(usersId),
        duration_id: selectedDurationId
          ? Number(selectedDurationId)
          : undefined,
      },
      skip: !usersId,
    }
  );
  const kpisData = data?.getEmployeeKpiByEmployeeId;
  const isEmployeeFeedBack =
    data?.getEmployeeKpiByEmployeeId[0]?.employee_completed;
  const isHeadFeedBack =
    data?.getEmployeeKpiByEmployeeId[0]?.dept_head_completed;

  const endDateStr = data?.getEmployeeKpiByEmployeeId[0]?.duration?.end_date;
  let isKpiFeature = false;
  if (endDateStr) {
    const endDate = moment(endDateStr).startOf("day");
    const today = moment().startOf("day");
    isKpiFeature = endDate.isSameOrBefore(today);
  }

  const durationOptions = kpiDurationData?.getAllKpiDuration?.data?.map(
    (item) => ({
      label: `${moment(item.start_date).format("MMMM, YYYY")} to ${moment(
        item.end_date
      ).format("MMMM, YYYY")}`,
      value: item.id,
    })
  );
  const kpiListData = data?.getEmployeeKpiByEmployeeId[0];

  const LoadUpdateUserProfile = useQuery(GET_USER_BY_ID, {
    skip: !usersId,
    variables: {
      id: Number(usersId),
    },
  });
  let [color, setColor] = useState("rgb(54, 215, 183)");

  const { years, months, days } = ageCalculator(
    new Date(
      LoadUserProfile?.data?.getUserByUserid?.additionalInfo?.joining_date
    )
  );
  console.log(
    "🚀 ~ AgentProfile ~ LoadUserProfile casual:",
    LoadUserProfile?.data?.getUserByUserid?.additionalInfo?.casual
  );
  useEffect(() => {
    if (!selectedDurationId) {
      setFilteredData(kpisData || []); // No filter, show all
    } else {
      const filtered = (kpisData || []).filter(
        (entry) => entry.duration?.id?.toString() === selectedDurationId
      );
      setFilteredData(filtered);
    }
  }, [selectedDurationId, kpisData]);

  const handleDelete = (id, name) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Delete certificate "${name}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteUserCertificate({ variables: { id } });
          Swal.fire("Deleted!", "Certificate has been removed.", "success");
        } catch (error) {
          Swal.fire("Error", "Failed to delete certificate.", "error");
        }
      }
    });
  };
  const handleDeleteMember = (id, name) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Delete member "${name}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteUserFamilyInfo({ variables: { id } });
          LoadUpdateUserProfile.refetch();
          Swal.fire("Deleted!", "member has been removed.", "success");
        } catch (error) {
          Swal.fire("Error", "Failed to delete member.", "error");
        }
      }
    });
  };
  const familyRefetch = LoadUpdateUserProfile?.refetch;
  const grouped = Object.values(
    (filteredData || []).reduce((acc, item) => {
      const duration = item.duration;
      const durationId = duration?.id;

      if (!durationId) return acc;

      if (!acc[durationId]) {
        acc[durationId] = {
          duration,
          kpis: [],
        };
      }

      acc[durationId].kpis.push(item);
      return acc;
    }, {})
  );
  const totalTarget = grouped[0]?.kpis?.reduce(
    (sum, item) => sum + Number(item.target || 0),
    0
  );
  const totalAchieved = grouped[0]?.kpis?.reduce(
    (sum, item) => sum + Number(item?.dept_head_completed || 0),
    0
  );
  const progressPercentage = (totalAchieved / totalTarget) * 100 || 0;
  const [updateEmergencyFamilyInfo, { loading: emergengyLoading }] =
    useMutation(UPDATE_EMERGENCY_FAMILY_INFO);
  const handleSetEmergency = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to set this member as the emergency contact?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, set it!",
    });

    if (!confirm.isConfirmed) return;

    try {
      const { data } = await updateEmergencyFamilyInfo({
        variables: {
          id,
          user_id: usersId,
        },
      });

      const response = data?.updateEmergencyFamilyInfo;
      if (response?.result_code == "200") {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: response.message || "Emergency contact updated successfully!",
        });

        LoadUpdateUserProfile.refetch();
        return;
      } else {
        await Swal.fire({
          icon: "error",
          title: "Failed",
          text: response?.message || "Failed to update emergency contact.",
        });
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Unexpected Error",
        text: "Something went wrong while updating emergency contact.",
      });
    }
  };

  return (
    <Container>
      <div className="profile">
        <Row>
          <Col md={8} className="mx-auto">
            <Card>
              <CardBody>
                {LoadUserProfile?.loading ? (
                  <Row className="align-items-center justify-content-center">
                    <SubmitLoading color="black" />
                  </Row>
                ) : (
                  <Row>
                    <Col>
                      <Row>
                        <Col
                          md={4}
                          className="d-flex justify-content-center align-items-center "
                        >
                          <div className="profile__avatar">
                            <img
                              className="img-fluid"
                              // src={
                              //   LoadUserProfile?.data?.getUserByUserid?.images
                              // }
                              src={`${imageUrl}/users/${
                                LoadUserProfile?.data?.getUserByUserid
                                  ?.images ||
                                "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png"
                              }`}
                              alt="Profile"
                              onError={(e) => {
                                e.target.onerror = null; // Prevents looping if the fallback image also fails
                                e.target.src =
                                  "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png";
                              }}
                            />
                          </div>
                        </Col>
                        <Col md={8}>
                          <Row>
                            <Col md={11}>
                              {" "}
                              <div>
                                <div className="d-flex">
                                  <h4 className="profile__name">
                                    {
                                      LoadUserProfile?.data?.getUserByUserid
                                        ?.name
                                    }
                                  </h4>
                                  <span className="ml-2">
                                    {`
                                (${LoadUserProfile?.data?.getUserByUserid?.username})`}
                                  </span>
                                </div>

                                <p className="profile__work">
                                  {LoadUserProfile?.data?.getUserByUserid
                                    .departments?.length
                                    ? LoadUserProfile?.data?.getUserByUserid.departments
                                        ?.map((d) => d.name)
                                        .join(", ")
                                    : "N/A"}
                                  ,{" "}
                                  {
                                    LoadUserProfile?.data?.getUserByUserid
                                      ?.additionalInfo?.designationInfo?.name
                                  }
                                </p>
                              </div>
                            </Col>
                            {userId == user.id || (!userId && user.id) ? (
                              <Col md={1} className="text-end">
                                <FiEdit
                                  className="profile-edit-btn"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    history.push({
                                      pathname: "/profile/update",
                                      state: {
                                        user: LoadUpdateUserProfile?.data
                                          ?.getUserById,
                                        id: usersId,
                                      },
                                    })
                                  }
                                />
                              </Col>
                            ) : null}
                          </Row>

                          <Row>
                            <Col md={6}>
                              <div className="panel__title mb-1">
                                <h5 className="bold-text">Contact</h5>
                              </div>
                              <table className="project-summary__info">
                                <tbody>
                                  <tr>
                                    <th>Email:</th>
                                    <td>
                                      {
                                        LoadUserProfile?.data?.getUserByUserid
                                          ?.email
                                      }
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Phone:</th>
                                    <td>
                                      {
                                        LoadUserProfile?.data?.getUserByUserid
                                          ?.phone
                                      }
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>LinkedIn:</th>
                                    <td>
                                      {LoadUserProfile?.data?.getUserByUserid
                                        ?.linkedin ? (
                                        <a
                                          href={
                                            LoadUserProfile.data.getUserByUserid
                                              .linkedin
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          Link
                                        </a>
                                      ) : (
                                        "N/A"
                                      )}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>

                            <Col xs={6} className="mt-3">
                              <div className="text-center">
                                <Button
                                  onClick={() => setIsChangePasswordOpen(true)}
                                  className="btn-sm"
                                >
                                  Change Password
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                    <Col xs={12} className="mt-5">
                      <div className="panel__title mb-2">
                        <h5 className="fw-bold">Personal Information</h5>
                      </div>{" "}
                    </Col>
                    <Col md={3} className="mb-2">
                      {" "}
                      <span className="project-summary__info text-muted">
                        Date of Birth :{" "}
                        {LoadUserProfile?.data?.getUserByUserid?.additionalInfo
                          ?.date_of_birth || "N/A"}
                      </span>
                    </Col>
                    <Col md={2} className="mb-2">
                      {" "}
                      <span className="project-summary__info text-muted">
                        Blood Group :{" "}
                        {LoadUserProfile?.data?.getUserByUserid?.additionalInfo
                          ?.blood_group || "N/A"}
                      </span>
                    </Col>
                    <Col md={3} className="mb-2">
                      {" "}
                      <span className="project-summary__info text-muted">
                        NID :{" "}
                        {LoadUserProfile?.data?.getUserByUserid?.additionalInfo
                          ?.nid || "N/A"}
                      </span>
                    </Col>
                    <Col md={4} className="mb-2">
                      {" "}
                      <span className="project-summary__info text-muted">
                        E-TIN :{" "}
                        {LoadUserProfile?.data?.getUserByUserid?.additionalInfo
                          ?.e_tin || "N/A"}
                      </span>
                    </Col>
                    {/* Personal Information end*/}
                    <Col xs={12} className="mt-2">
                      <Row>
                        <Col xs={6}>
                          <Row>
                            <Col xs={12}>
                              <div className="panel__title mb-1">
                                <h5 className="bold-text">Office Info</h5>
                              </div>
                              <table className="project-summary__info ">
                                <tbody>
                                  <tr>
                                    <th>Office ID:</th>
                                    <td>
                                      {
                                        LoadUserProfile?.data?.getUserByUserid
                                          ?.additionalInfo?.office_id
                                      }
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>RFID:</th>
                                    <td>
                                      {
                                        LoadUserProfile?.data?.getUserByUserid
                                          ?.additionalInfo?.rfid
                                      }
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Joining Date:</th>
                                    <td>
                                      {dateTime(
                                        new Date(
                                          LoadUserProfile?.data?.getUserByUserid?.additionalInfo?.joining_date
                                        ).getTime(),
                                        "DD/MM/YYYY"
                                      )}{" "}
                                      ({`${years}Y ${months}M ${days}D`})
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>
                            {/*  */}

                            {/*  */}
                            <Col xs={12}>
                              <div className="panel__title mb-2">
                                <h5 className="fw-bold">Address</h5>
                              </div>

                              <Row>
                                <Col md={12} className="mb-2">
                                  <span>
                                    {LoadUserProfile?.data?.getUserByUserid
                                      ?.village || "-"}
                                  </span>
                                  <span className="mr-2">,</span>
                                  <span>
                                    {LoadUserProfile?.data?.getUserByUserid
                                      ?.unionInfo?.name || "-"}
                                  </span>
                                  <span className="mr-2">,</span>
                                  <span>
                                    {LoadUserProfile?.data?.getUserByUserid
                                      ?.upazillaInfo?.name || "-"}
                                  </span>
                                </Col>
                                <Col md={12} className="mb-2">
                                  <span>
                                    {LoadUserProfile?.data?.getUserByUserid
                                      ?.districtInfo?.name || "-"}
                                  </span>
                                  <span className="mr-2">,</span>
                                  <span>
                                    {LoadUserProfile?.data?.getUserByUserid
                                      ?.divisionInfo?.name || "-"}
                                  </span>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={6}>
                          <Row>
                            <Col xs={12}>
                              <div className="panel__title mb-1">
                                <h5 className="bold-text">Leave Left</h5>
                              </div>
                              <table className="project-summary__info">
                                <tbody>
                                  {LoadUserProfile?.data?.getUserByUserid
                                    ?.gender === "Male" ? (
                                    <>
                                      <tr>
                                        <th>Casual:</th>
                                        <td>
                                          {(LoadUserProfile?.data
                                            ?.getUserByUserid?.additionalInfo
                                            ?.casual || 0) -
                                            (totalPending?.Casual || 0)}{" "}
                                          {totalPending?.Casual ? (
                                            <span className="text-muted">{`(Pending ${totalPending?.Casual})`}</span>
                                          ) : null}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Sick:</th>
                                        <td>
                                          {(LoadUserProfile?.data
                                            ?.getUserByUserid?.additionalInfo
                                            ?.sick || 0) -
                                            (totalPending?.Sick || 0)}{" "}
                                          {totalPending?.Sick ? (
                                            <span className="text-muted">{`(Pending ${totalPending?.Sick})`}</span>
                                          ) : null}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Anual:</th>
                                        <td>
                                          {(LoadUserProfile?.data
                                            ?.getUserByUserid?.additionalInfo
                                            ?.anual || 0) -
                                            (totalPending?.Anual || 0)}{" "}
                                          {totalPending?.Anual ? (
                                            <span className="text-muted">{`(Pending ${totalPending?.Anual})`}</span>
                                          ) : null}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Reimburse:</th>
                                        <td>
                                          {(LoadUserProfile?.data
                                            ?.getUserByUserid?.additionalInfo
                                            ?.reimburse || 0) -
                                            (totalPending?.Reimburse || 0)}{" "}
                                          {totalPending?.Reimburse ? (
                                            <span className="text-muted">{`(Pending ${totalPending?.Reimburse})`}</span>
                                          ) : null}
                                        </td>
                                      </tr>
                                    </>
                                  ) : (
                                    <>
                                      <tr>
                                        <th>Casual:</th>
                                        <td>
                                          {(LoadUserProfile?.data
                                            ?.getUserByUserid?.additionalInfo
                                            ?.casual || 0) -
                                            (totalPending?.Casual || 0)}{" "}
                                          {totalPending?.Casual ? (
                                            <span className="text-muted">{`(Pending ${totalPending?.Casual})`}</span>
                                          ) : null}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Sick:</th>
                                        <td>
                                          {(LoadUserProfile?.data
                                            ?.getUserByUserid?.additionalInfo
                                            ?.sick || 0) -
                                            (totalPending?.Sick || 0)}{" "}
                                          {totalPending?.Sick ? (
                                            <span className="text-muted">{`(Pending ${totalPending?.Sick})`}</span>
                                          ) : null}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Anual:</th>
                                        <td>
                                          {(LoadUserProfile?.data
                                            ?.getUserByUserid?.additionalInfo
                                            ?.anual || 0) -
                                            (totalPending?.Anual || 0)}{" "}
                                          {totalPending?.Anual ? (
                                            <span className="text-muted">{`(Pending ${totalPending?.Anual})`}</span>
                                          ) : null}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Reimburse:</th>
                                        <td>
                                          {(LoadUserProfile?.data
                                            ?.getUserByUserid?.additionalInfo
                                            ?.reimburse || 0) -
                                            (totalPending?.Reimburse || 0)}{" "}
                                          {totalPending?.Reimburse ? (
                                            <span className="text-muted">{`(Pending ${totalPending?.Reimburse})`}</span>
                                          ) : null}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Maternity:</th>
                                        <td>
                                          {(LoadUserProfile?.data
                                            ?.getUserByUserid?.additionalInfo
                                            ?.maternity || 0) -
                                            (totalPending?.Maternity || 0)}{" "}
                                          {totalPending?.Maternity ? (
                                            <span className="text-muted">{`(Pending ${totalPending?.Maternity})`}</span>
                                          ) : null}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Menstrual:</th>
                                        <td>
                                          {(LoadUserProfile?.data
                                            ?.getUserByUserid?.additionalInfo
                                            ?.menstrual || 0) -
                                            (totalPending?.Menstrual || 0)}{" "}
                                          {totalPending?.Menstrual ? (
                                            <span className="text-muted">{`(Pending ${totalPending?.Menstrual})`}</span>
                                          ) : null}
                                        </td>
                                      </tr>
                                    </>
                                  )}
                                </tbody>
                              </table>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                    <Col xs={12} className="mt-4">
                      <div className=" position-relative">
                        {/* Button Group - Top Right */}
                        <div className="d-flex justify-content-between align-items-center">
                          <h4 className="text-center fw-bold bold-text">
                            <i className="bi bi-briefcase-fill me-2"></i>
                            Family Informations
                          </h4>
                          <FiUserPlus
                            className="profile-edit-btn"
                            size={20}
                            style={{ cursor: "pointer" }}
                            title="Add Family Member"
                            onClick={() => openEditModal(null)}
                          />
                        </div>

                        <Card>
                          <CardBody>
                            {LoadUserProfile?.data?.getUserByUserid?.familyInfo
                              ?.length > 0 ? (
                              <Table bordered responsive hover className="mb-0">
                                <thead className="table-light">
                                  <tr>
                                    <th>#</th>
                                    <th>Name </th>
                                    {/* <th>Set Emergency</th> */}
                                    <th>Mobile</th>
                                    <th>Relation</th>
                                    <th className="text-center">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {LoadUserProfile?.data?.getUserByUserid?.familyInfo?.map(
                                    (family, idx) => {
                                      return (
                                        <tr key={idx}>
                                          <td className="align-middle">
                                            {idx + 1}
                                          </td>
                                          <td className="align-middle">
                                            {family?.name}
                                            {family?.is_emergency
                                              ? " (Emergency Contact)"
                                              : ""}
                                            {family?.is_died ? " (late)" : ""}
                                          </td>
                                          {/* <td>
                                            {" "}
                                            <Button
                                              color="warning"
                                              size="sm"
                                              onClick={() =>
                                                handleSetEmergency(family?.id)
                                              }
                                              disabled={loading}
                                            >
                                              {loading ? "Updating..." : "Set"}
                                            </Button>
                                          </td> */}
                                          <td className="align-middle">
                                            {family?.mobile
                                              ? family?.mobile
                                              : "N/A"}
                                          </td>
                                          <td className="align-middle">
                                            {family?.userRelation?.relation}
                                          </td>
                                          <td className="text-center">
                                            <button
                                              className="inbox__email-btn"
                                              type="button"
                                              aria-label="edit"
                                              onClick={() =>
                                                handleDeleteMember(
                                                  family.id,
                                                  family.name
                                                )
                                              }
                                            >
                                              <DeleteIcon fontSize="small" />
                                            </button>
                                            <button
                                              className="inbox__email-btn mr-1"
                                              type="button"
                                              aria-label="edit"
                                              onClick={() =>
                                                openEditModal(family)
                                              }
                                            >
                                              <EditIcon fontSize="small" />
                                            </button>

                                            <Tooltip
                                              title="Set as Emergency Contact"
                                              arrow
                                            >
                                              <button
                                                className="inbox__email-btn mr-1"
                                                type="button"
                                                aria-label="edit"
                                                onClick={() =>
                                                  handleSetEmergency(family?.id)
                                                }
                                              >
                                                <CategoryIcon fontSize="small" />
                                              </button>
                                            </Tooltip>
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </tbody>
                              </Table>
                            ) : (
                              <div className="text-muted text-center">
                                Add Your Family Informations
                              </div>
                            )}
                          </CardBody>
                        </Card>
                      </div>
                    </Col>
                    <Col xs={12} className="mt-4">
                      <div className=" position-relative">
                        {/* Button Group - Top Right */}
                        <div className="d-flex justify-content-between align-items-center">
                          <h4 className="text-center fw-bold bold-text">
                            <i className="bi bi-briefcase-fill me-2"></i>
                            Your Certificates
                          </h4>
                          <FiEdit
                            className="profile-edit-btn"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              history.push(`/profile/document/${usersId}`)
                            }
                          />
                        </div>

                        <Card>
                          <CardBody>
                            {LoadUserProfile?.data?.getUserByUserid
                              ?.certificates?.length > 0 ? (
                              <Table bordered responsive hover className="mb-0">
                                <thead className="table-light">
                                  <tr>
                                    <th>#</th>
                                    <th>Certificate Name</th>
                                    <th className="text-center">
                                      View Certificate
                                    </th>
                                    <th className="text-center">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {LoadUserProfile.data.getUserByUserid.certificates.map(
                                    (certificate, idx) => {
                                      const certUrl = `${imageUrl}/certificates/${certificate.certificate}`;
                                      return (
                                        <tr key={idx}>
                                          <td className="align-middle">
                                            {idx + 1}
                                          </td>
                                          <td className="align-middle">
                                            {certificate.name}
                                          </td>
                                          <td className="text-center">
                                            <a
                                              href={certUrl}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              title="View Certificate"
                                            >
                                              <VisibilityIcon fontSize="small" />
                                            </a>
                                          </td>
                                          <td className="text-center">
                                            <button
                                              className="inbox__email-btn"
                                              type="button"
                                              aria-label="edit"
                                              onClick={() =>
                                                handleDelete(
                                                  certificate.id,
                                                  certificate.name
                                                )
                                              }
                                            >
                                              <DeleteIcon fontSize="small" />
                                            </button>
                                            <button
                                              className="inbox__email-btn mr-1"
                                              type="button"
                                              aria-label="edit"
                                              onClick={() =>
                                                history.push({
                                                  pathname: `/profile/document/${usersId}`,
                                                  state: {
                                                    certificate,
                                                  },
                                                })
                                              }
                                            >
                                              <EditIcon fontSize="small" />
                                            </button>
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </tbody>
                              </Table>
                            ) : (
                              <div className="text-muted text-center">
                                No certificates uploaded yet.
                              </div>
                            )}
                          </CardBody>
                        </Card>
                      </div>
                    </Col>
                    <Col xs={12} className="mt-4">
                      <div className=" position-relative">
                        <div className="d-flex justify-content-between align-items-center">
                          <h4 className="text-center fw-bold bold-text mb-4 ">
                            <i className="bi bi-briefcase-fill me-2"></i>
                            Job Description
                          </h4>
                          <FiEdit
                            className="profile-edit-btn"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              history.push(
                                `/profile/job-description/${usersId}`
                              )
                            }
                          />
                        </div>
                        {LoadUserProfile?.data?.getUserByUserid
                          ?.job_description ? (
                          <div
                            className="border p-3 "
                            dangerouslySetInnerHTML={{
                              __html:
                                LoadUserProfile?.data?.getUserByUserid
                                  ?.job_description,
                            }}
                          />
                        ) : (
                          <p className="text-center text-muted">
                            Please Add Your Job Description
                          </p>
                        )}
                      </div>
                    </Col>

                    {/* <Card className="mt-4">
                      <CardBody>
                        <Row className=" mb-3">
                          <Col md={4}>
                            <h4 className="mb-0">Employee KPI Details</h4>
                          </Col>

                          <Col md={4}>
                            <div style={{ width: 100, height: 100 }}>
                              <CircularProgressbar
                                value={progressPercentage}
                                text={`${progressPercentage}%`}
                                // value={percentage}
                                // text={`${percentage}%`}
                                styles={buildStyles({
                                  pathColor: "#28a745", // Bootstrap success green
                                  textColor: "#000",
                                  trailColor: "#eee",
                                  pathTransitionDuration: 1.5,
                                })}
                              />
                            </div>
                          </Col>
                          <Col md={4}>
                            <label className="form-label form__form-group-field">
                              Filter by Duration
                            </label>
                            <Input
                              type="select"
                              className="form-control form__form-group-field"
                              value={selectedDurationId}
                              onChange={(e) =>
                                setSelectedDurationId(e.target.value)
                              }
                            >
                              <option value="">Recent</option>
                              {durationOptions?.map((opt) => (
                                <option key={opt.id} value={opt.value}>
                                  {opt.label}
                                </option>
                              ))}
                            </Input>
                          </Col>
                        </Row>

                        {loading ? (
                          <div className="d-flex justify-content-center align-items-center">
                            <SubmitLoading color="black" />
                          </div>
                        ) : filteredData?.length === 0 ? (
                          <p className="text-center">No KPI data available.</p>
                        ) : (
                          <div className="mb-4">
                            <Table bordered responsive striped>
                              <thead className="thead-light">
                                <tr>
                                  <th>#</th>
                                  <th>KPI</th>
                                  <th>Weight</th>
                                  <th>Target</th>
                                  <th>Employee Completed</th>
                                  <th>Employee Comment</th>
                                  <th>Dept Head Completed</th>
                                  <th>Dept Head Comment</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {grouped[0]?.kpis?.map((kpi, kpiIndex) => (
                                  <tr key={kpi?.kpiList?.id}>
                                    <td>{kpiIndex + 1}</td>
                                    <td>{kpi?.kpiList?.key_area}</td>
                                    <td>{kpi?.kpiList?.weight}</td>
                                    <td>{kpi.target ?? "-"}</td>
                                    <td>{kpi.employee_completed ?? "-"}</td>
                                    <td>{kpi.employee_comment ?? "-"}</td>
                                    <td>{kpi.dept_head_completed ?? "-"}</td>
                                    <td>{kpi.dept_head_comment ?? "-"}</td>
                                    <td>
                                      {" "}
                                      {permissions?.includes(
                                        "update_department"
                                      ) &&
                                        kpi.employee_comment && (
                                          <Tooltip
                                            title="Department Feedback"
                                            arrow
                                          >
                                            <button
                                              className="inbox__email-btn"
                                              type="button"
                                              aria-label="add"
                                              onClick={() =>
                                                openDeptModal(
                                                  LoadUserProfile?.data
                                                    ?.getUserByUserid,
                                                  "dept",
                                                  kpi?.id
                                                )
                                              }
                                            >
                                              <AddIcon fontSize="small" />
                                            </button>
                                          </Tooltip>
                                        )}
                                      {isKpiFeature &&
                                        !kpi.dept_head_completed &&
                                        LoadUserProfile?.data?.getUserByUserid
                                          .id == user.id && (
                                          <Tooltip
                                            title="Employee Feedback"
                                            arrow
                                          >
                                            <button
                                              className="inbox__email-btn"
                                              type="button"
                                              aria-label="add"
                                              onClick={() =>
                                                openDeptModal(
                                                  LoadUserProfile?.data
                                                    ?.getUserByUserid,
                                                  "kpi",
                                                  kpi?.id
                                                )
                                              }
                                            >
                                              <AddIcon fontSize="small" />
                                            </button>
                                          </Tooltip>
                                        )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        )}
                      </CardBody>
                    </Card> */}
                  </Row>
                )}
              </CardBody>
            </Card>
          </Col>
          <Col md={12}></Col>
        </Row>
      </div>
      <FamilyInfoModal
        modal={editModalOpen}
        toggle={closeEditModal}
        userId={usersId}
        defaultData={selectedFamily}
        refetch={familyRefetch}
      />

      {deptModalOpen && (
        <KpiFeedBackModal
          modal={deptModalOpen}
          toggle={closeDeptModal}
          userId={usersId}
          kpiId={kpiId}
          defaultData={selectedFamily}
          type={modalType}
          refetchData={refetch}
        />
      )}

      <ChangePasswordModal
        isOpen={isChangePasswordOpen}
        toggle={() => setIsChangePasswordOpen(!isChangePasswordOpen)}
        userId={usersId}
      />
    </Container>
  );
};

export default AgentProfile;
